import React, { useState } from "react";
import "./AchievementCard.scss";

export default function AchievementCard({ cardInfo, isDark }) {
  const [isImageFullScreen, setImageFullScreen] = useState(false);

  // Toggle full-screen view
  const toggleFullScreen = () => {
    setImageFullScreen(!isImageFullScreen);
  };

  function openUrlInNewTab(url, name) {
    if (!url) {
      console.log(`URL for ${name} not found`);
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  return (
    <div className={isDark ? "dark-mode certificate-card" : "certificate-card"}>
      {/* Image container */}
      <div className="certificate-image-div">
        <img
          src={cardInfo.image}
          alt={cardInfo.imageAlt || "Card Thumbnail"}
          className="card-image"
          onClick={toggleFullScreen} // Enlarge image on click
        />
      </div>

      {/* Full-screen image view */}
      {isImageFullScreen && (
        <div className="fullscreen-overlay" onClick={toggleFullScreen}>
          <img
            src={cardInfo.image}
            alt={cardInfo.imageAlt || "Full-Screen View"}
            className="fullscreen-image"
          />
        </div>
      )}

      {/* Certificate details */}
      <div className="certificate-detail-div">
        <h5 className={isDark ? "dark-mode card-title" : "card-title"}>
          {cardInfo.title}
        </h5>
        <p className={isDark ? "dark-mode card-subtitle" : "card-subtitle"}>
          {cardInfo.description}
        </p>
      </div>
    </div>
  );
}
